export type RenderStaleCheck = () => boolean

let activeRenderId = 0

export function nextRenderGeneration(): { id: number; isStale: RenderStaleCheck } {
  const id = ++activeRenderId
  return {
    id,
    isStale: () => id !== activeRenderId,
  }
}
